// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__12LcK","radioRow":"SimpleQuestionBuilderModal_radioRow__1q0OI"};